import {Injectable} from "@angular/core";
import {ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {Router} from "@angular/router";

import {TranslateServiceForm} from "../translate/translate.service";
import {MamContentsComponent} from '../mam_contents.component';


@Injectable()
export class InterceptedHttp extends Http {
    private router: Router;
    private translate:TranslateServiceForm;

    private ERROR_REACHED_MAX_SESSION:number        = 902;
    private LANG_SESSION_TIMEOUT:number             = 401;
    private SESSION_EXPIRED:number                  = 901;
    private ERROR_SESSION_TIMEOUT:number            = 903;

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, _translate: TranslateServiceForm, private _router: Router) {
        super(backend, defaultOptions);
        this.translate = _translate;
        this.router = _router;
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        this.setTimerCheck();
        return super.get(url, this.getRequestOptionArgs(options)).catch((error: Response) => {
            return Observable.throw(error);
        });
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
         this.setTimerCheck();
        return super.post(url, body, this.getRequestOptionArgs(options)).catch((error: Response) => {
            this.errorForHttp(error.status);
            return Observable.throw(error);
        });
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
         this.setTimerCheck();
        return super.put(url, body, this.getRequestOptionArgs(options)).catch((error: Response) => {
            this.errorForHttp(error.status);
            return Observable.throw(error);
        });
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
         this.setTimerCheck();
        return super.delete(url, this.getRequestOptionArgs(options)).catch((error: Response) => {
            this.errorForHttp(error.status);
            return Observable.throw(error);
        });
    }

    private setTimerCheck () : void {
        MamContentsComponent.timer_checkTime =  MamContentsComponent.timer_sessionMaxInactiveInterval;
    }

    private errorForHttp (code: number):void {
    
        switch(code) {
            case this.LANG_SESSION_TIMEOUT :
                alert(this.translate.instant("LANG_SESSION_TIMEOUT"));
                this.router.navigate(["/login"]);
            break ;

            case this.ERROR_SESSION_TIMEOUT :
                alert(this.translate.instant("LANG_SESSION_TIMEOUT"));
                this.router.navigate(["/login"]);
            break ;

            case this.ERROR_REACHED_MAX_SESSION :
                alert(this.translate.instant("LANG_LOGIN_MAX_OVER_ERROR"));
                this.router.navigate(["/login"]);
            break ;
        }
    };

    private getRequestOptionArgs(httpOptions?: RequestOptionsArgs) : RequestOptionsArgs {
        if (httpOptions == null) {
            httpOptions = new RequestOptions();
        }
        if (httpOptions.headers == null) {
            httpOptions.headers = new Headers();
        }
        httpOptions.withCredentials  = true;
        httpOptions.headers.append("Cache-Control", "no-cache, no-store, must-revalidate");
        httpOptions.headers.append("Pragma", "no-cache");
        httpOptions.headers.append("Expires", "-1");
        return httpOptions;
    };
}



// WEBPACK FOOTER //
// ./src/app/factory/http.interceptor.ts